import { useState, useEffect } from 'react';

import { _QuotaTimeTerm, _ThirdLoanEntity } from '../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../core/services/dataBean/useDataBean';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const QuotaTimeTermSelect = ({ idSelector, onChange, label }: Props) => {

    const { instance } = useDataBean(_QuotaTimeTerm);
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }


    const getLista = () => {
        instance.getQuotaTimeTermCatalog(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    return (
        <>
            <label>{label ?? "Tipos de Cuota:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDQuotaTimeTerm} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}